import React from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import SEOHead from "@/components/SEOHead";

const RefundPolicy: React.FC = () => {
  return (
    <>
      <SEOHead
        title="Return & Refund Policy: Ieshia Danielle"
        description="Return and refund policies for products, workbooks, workshops, and coaching programs by Ieshia Danielle."
        canonical="https://iamieshiadanielle.com/refunds"
      />
      <div className="min-h-screen bg-[#FAF6F0] text-[#380C1E] flex flex-col font-sans">
        <Header />
        <main className="flex-1 py-16 md:py-24 px-4">
          <div className="max-w-4xl mx-auto bg-white/70 backdrop-blur-md border border-[#E8DEC8] p-8 md:p-12 rounded-3xl shadow-sm">
            <p className="text-xs uppercase font-semibold tracking-widest text-[#9E1B50] mb-2">
              IESHIA DANIELLE
            </p>
            <h1 className="font-serif text-3xl md:text-5xl font-normal text-[#380C1E] mb-4">
              Return & Refund Policy
            </h1>
            <p className="text-xs text-[#380C1E]/70 mb-8 font-medium">
              Effective date: July 25, 2026 | Last updated: July 25, 2026
            </p>

            <div className="space-y-6 text-sm md:text-base leading-relaxed text-[#380C1E]/90 font-light">
              <p>
                This policy applies to all purchases made through
                iamieshiadanielle.com and its connected order and checkout pages
                (the "Site"), operated by Ieshia Danielle ("we," "us," or
                "our").
              </p>

              <h2 className="font-serif text-2xl font-normal text-[#380C1E] pt-6 pb-2 border-t border-[#E8DEC8]">
                1. All Sales Are Final
              </h2>
              <p>
                Except as expressly stated in this policy, all sales are final.
                We do not offer returns, exchanges, replacements, or refunds.
              </p>

              <h2 className="font-serif text-2xl font-normal text-[#380C1E] pt-6 pb-2 border-t border-[#E8DEC8]">
                2. Physical Products & Downloads
              </h2>
              <p>
                All physical products (workbooks, shop items) and instant
                digital downloads are final sale.
              </p>

              <h2 className="font-serif text-2xl font-normal text-[#380C1E] pt-6 pb-2 border-t border-[#E8DEC8]">
                3. The Becoming Intensive
              </h2>
              <p>
                Cancellations received 7 or more days prior to cohort start date
                are eligible for a full refund. Under 7 days, enrollment may be
                transferred 1 time to a future cohort.
              </p>

              <h2 className="font-serif text-2xl font-normal text-[#380C1E] pt-6 pb-2 border-t border-[#E8DEC8]">
                4. Contact Us
              </h2>
              <p>
                Email:{" "}
                <a
                  href="mailto:admin@mail.iamieshiadanielle.com"
                  className="text-[#9E1B50] underline"
                >
                  admin@mail.iamieshiadanielle.com
                </a>
              </p>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
};

export default RefundPolicy;
